function smoothScroll() {
	//Homepage down arrow
	$('#page__front-page .down-arrows').on('click', function(e) {
		e.preventDefault();

		var parentSection = $(this).closest('section');

		//Scroll to section
		$('html, body').animate({
			scrollTop: parentSection.next().offset().top - $('header').outerHeight()
		}, 800);
	});

	//Type of events scrollon page load (if coming from other event child page)		
    if(window.location.href.indexOf('events/#type-of-event') > -1) {
		var section = $('#event-type-link').data('scroll');

		//Scroll to section
		$('html, body').animate({
			scrollTop: $(section).offset().top - $('header').outerHeight()
		}, 800);		
    }

    if (window.location.href.indexOf('?section=') > -1) {
    	var section = getParameterByName('section');

    	setTimeout(function() {
			$('html, body').animate({
				scrollTop: $('section[data-section-name="'+section+'"]').offset().top - $('header').outerHeight()
			}, 800);
    	}, 400);
    }    

    //Type of events scroll to section (if on events page)
	$('.js__smooth-scroll').on('click', function(e) {
		e.preventDefault();
		var section = $(this).data('scroll');

		if ( $('.events-hamburger').hasClass('active') ) {
			$('.events-hamburger').trigger('click');
		}

		//Scroll to section
		$('html, body').animate({
			scrollTop: $(section).offset().top - $('header').outerHeight()
		}, 800);			
	});
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}